import { useEffect, useState } from "react";
import {
  getCombos,
  getFichaCaracterizacion,
  getCboMunicipios,
  setCaracterizacion,
  setPlantillaSencilla,
  updateCaracterizacion,
} from "../componentes/api.js";
import VentanaCrear from "../comun/VentanaCrear.jsx";
import TextField from "@mui/material/TextField";
import { FaFileMedical } from "react-icons/fa";
import {
  Alert,
  Divider,
  FormControlLabel,
  FormGroup,
  Stack,
  Switch,
} from "@mui/material";
import Form from "react-bootstrap/Form";
import BarraBotones from "../comun/BarraBotones.jsx";
import { RUTA_SERVIDOR } from "../componentes/config.js";

const Caracterizacion = (props) => {
  /**Para cargar los datos de los combos */
  const [cargando, setCargando] = useState(false);
  const [tipoDocumentos, setTipoDocumentos] = useState([]);
  const [familiaridad, setFamiliaridad] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [listaEps, setListaEps] = useState([]);
  const [mostrarCrear, setMostrarCrear] = useState(false);
  const [datos, setDatos] = useState({
    Id: "",
    TipoDocumento: 0,
    NoDocumento: "",
    MunicipioExp: 0,
    Nbres: "",
    Apellidos: "",
    Celular: "",
    Genero: 1,
    FechaNacimiento: "",
    MunicipioNacimiento: 0,
    Discapacidad: false,
    MunicipioResidencia: 0,
    Direccion: "",
    Barrio: "",
    TipoVivienda: "1",
    Permanencia: "1",
    GrupoFamiliar: 2,
    Zona: "2",
    Estrato: "1",
    Vivienda: "2",
    Agua: false,
    Alcantarillado: false,
    Energia: false,
    Gas: false,
    Telefonia: false,
    Internet: false,
    Basuras: false,
    Poblacion: "7",
    Escolaridad: "1",
    Semestres: "1",
    Anios: "1",
    Baldios: false,
    Excencion: false,
    PrimeraInfancia: false,
    Infancia: false,
    AdolescenciaJuventud: false,
    Nutricion: false,
    Proteccion: false,
    Familias: false,
    TuEliges: false,
    Equidad: false,
    Excelencia: false,
    Petroleo: false,
    Subsidiado: false,
    CasaDigna: false,
    ViviendaRural: false,
    ColombiaMayor: false,
    FamiliasAccion: false,
    JovenesAccion: false,
    Unidos: false,
    IngresoSolidario: false,
    Iva: false,
    Resa: false,
    MiNegocio: false,
    Colectivo: false,
    ExeccionCedula: false,
    Pae: false,
    AtencionHumanitaria: false,
    Sisben: 0,
    Eps: 0,
    Ocupacion: "1",
    Bicicleta: false,
    Moto: false,
    Carro: false,
    Leer: false,
    Escribir: false,
    Cantar: false,
    Bailar: false,
    Deportista: false,
    Principal: "",
    Familiaridad: 0,
    Correo: "",
    Clave: "",
    Activo: true,
    IdUsuario: props.idUsuario,
    IdProyecto: props.idProyecto,
  });

  useEffect(() => {
    nuevo();
    cargarCombos({ Tabla: "tipo_documento", Campo: "" }, "tipoDocumento");
    cargarCombos({ Tabla: "eps", Campo: "" }, "eps");
    cargarCombos({ Tabla: "familiaridad", Campo: "" }, "familiaridad");
    cargarMunicipios();
  }, []);

  const asignarDato = (event) => {
    event.preventDefault();

    if (event.target.type === "checkbox") {
      setDatos({ ...datos, [event.target.name]: event.target.checked });
    } else {
      setDatos({ ...datos, [event.target.name]: event.target.value });
    }
  };

  const buscarFichaCaracterizacion = async (doc) => {
    try {
      setCargando(true);
      const response = await getFichaCaracterizacion({
        IdProyecto: props.idProyecto,
        NoDocumento: doc,
      });
      if (response.data.length !== 0) {
        setDatos(response.data[0]);
        setDatos({
          ...datos,
          ["FechaNacimiento"]:
            response.data[0].FechaNacimiento.toString().substring(0, 10),
        });
        setCargando(false);
      } else {
        setCargando(false);
      }
    } catch (error) {
      setCargando(false);
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al buscar la existencia de una Ficha de Caracterización del Beneficiario",
        error,
      ]);
    }
  };

  const botones = (boton) => {
    if (boton === 0) nuevo(); //Nuevo
    else if (boton === 1) validarDatos(); //Grabar registro
    else if (boton === 2) imprimir(); //Imprimir registro
    else if (boton === 3) exportar(); //Exportar registro
    else if (boton === 4) nuevo(); //Limpiar, igual a nuevo
  };

  const cargarCombos = async (datos, cbo) => {
    try {
      setCargando(true);
      const response = await getCombos(datos);
      if (cbo === "tipoDocumento") {
        setTipoDocumentos(response.data);
      } else if (cbo === "municipios") {
        setMunicipios(response.data);
      } else if (cbo === "familiaridad") {
        setFamiliaridad(response.data);
      } else if (cbo === "eps") {
        setListaEps(response.data);
      }
      setCargando(false);
    } catch (error) {
      setCargando(false);
      props.Msg(["ERROR", "Ocurrio un error al cargar los Combos", error]);
    }
  };

  const cargarMunicipios = async () => {
    try {
      setCargando(true);
      const response = await getCboMunicipios();
      setMunicipios(response.data);
      setCargando(false);
    } catch (error) {
      setCargando(false);
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al cargar los Municipios",
        error,
      ]);
    }
  };

  const cerrarVentanaCrear = () => {
    setMostrarCrear(false);
  };

  const exportar = () => {
    props.mostrarMsg(["OK, exportará los datos"]);
  };

  const grabarCampo = async (nbre) => {
    try {
      setCargando(true);
      let plantilla = {
        tabla: "tipo_documento",
        nbre: nbre,
        activo: "1",
        idUsuario: props.idUsuario,
      };
      await setPlantillaSencilla(plantilla);
      cargarCombos({ Tabla: "tipo_documento", Campo: "" }, "tipoDocumento");
      setCargando(false);
    } catch (error) {
      setCargando(false);
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al Grabar el Tipo de Documento",
        error,
      ]);
    }
  };

  const grabarRegistro = async () => {
    try {
      setCargando(true);
      const result = await setCaracterizacion(datos);
      setDatos({ ...datos, ["Id"]: result.data.Id });
      setCargando(false);
      props.mostrarMsg(["Ficha grabada con ID", result.data.Id]);
    } catch (error) {
      setCargando(false);
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al Grabar al Beneficiario del Proyecto",
        error,
      ]);
    }
  };

  const imprimir = () => {
    props.mostrarMsg(["OK, Imprime los datos"]);
  };

  const modificarRegistro = async () => {
    try {
      setCargando(true);
      await updateCaracterizacion(datos);
      setCargando(false);
      props.mostrarMsg(["Se actualizaron los datos del Beneficiario!"]);
    } catch (error) {
      setCargando(false);
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al Modificar los Datos del Beneficiario del Proyecto",
        error,
      ]);
    }
  };

  const mostrarVentanaCrear = (event, titulo) => {
    event.preventDefault();
    setMostrarCrear(true);
  };

  const nuevo = () => {
    setDatos({
      Id: "",
      TipoDocumento: datos.TipoDocumento || 0,
      NoDocumento: "",
      MunicipioExp: 0,
      Nbres: "",
      Apellidos: "",
      Celular: "",
      Genero: datos.Genero || 1,
      FechaNacimiento: "",
      MunicipioNacimiento: 0,
      Discapacidad: datos.Discapacidad || false,
      MunicipioResidencia: datos.MunicipioResidencia || 0,
      Direccion: "",
      Barrio: "",
      TipoVivienda: datos.TipoVivienda || "1",
      Permanencia: datos.Permanencia || "1",
      GrupoFamiliar: 2,
      Zona: datos.Zona || "2",
      Estrato: datos.Estrato || "1",
      Vivienda: datos.Vivienda || "2",
      Agua: datos.Agua || false,
      Alcantarillado: datos.Alcantarillado || false,
      Energia: datos.Energia || false,
      Gas: datos.Gas || false,
      Telefonia: datos.Telefonia || false,
      Internet: datos.Internet || false,
      Basuras: datos.Basuras || false,
      Poblacion: datos.Poblacion || "7",
      Escolaridad: datos.Escolaridad || "1",
      Semestres: datos.Semestres || 1,
      Anios: datos.Anios || "1",
      Baldios: datos.Baldios || false,
      Excencion: datos.Excencion || false,
      PrimeraInfancia: datos.PrimeraInfancia || false,
      Infancia: datos.Infancia || false,
      AdolescenciaJuventud: datos.AdolescenciaJuventud || false,
      Nutricion: datos.Nutricion || false,
      Proteccion: datos.Proteccion || false,
      Familias: datos.Familias || false,
      TuEliges: datos.TuEliges || false,
      Equidad: datos.Equidad || false,
      Excelencia: datos.Excelencia || false,
      Petroleo: datos.Petroleo || false,
      Subsidiado: datos.Subsidiado || false,
      CasaDigna: datos.SasaDigna || false,
      ViviendaRural: datos.ViviendaRural || false,
      ColombiaMayor: datos.ColombiaMayor || false,
      FamiliasAccion: datos.FamiliasAccion || false,
      JovenesAccion: datos.JovenesAccion || false,
      Unidos: datos.Unidos || false,
      IngresoSolidario: datos.IngresoSolidario || false,
      Iva: datos.Iva || false,
      Resa: datos.Resa || false,
      MiNegocio: datos.MiNegocio || false,
      Colectivo: datos.Colectivo || false,
      ExeccionCedula: datos.ExeccionCedula || false,
      Pae: datos.Pae || false,
      AtencionHumanitaria: datos.AtencionHumanitaria || false,
      Sisben: 0,
      Eps: datos.Eps || 0,
      Ocupacion: datos.Ocupacion || "1",
      Bicicleta: datos.Bicicleta || false,
      Moto: datos.Moto || false,
      Carro: datos.Carro || false,
      Leer: datos.Leer || false,
      Escribir: datos.Escribir || false,
      Cantar: datos.Cantar || false,
      Bailar: datos.Bailar || false,
      Deportista: datos.Deportista || false,
      Principal: "",
      Familiaridad: 0,
      Correo: "",
      Clave: "",
      Activo: true,
      IdUsuario: props.idUsuario,
      IdProyecto: props.idProyecto,
    });
  };

  const validarDatos = () => {
    setCargando(true);
    if (datos.Nbres === "") {
      props.mostrarMsg(["Por favor digite los Nombres!"]);
      setCargando(false);
    } else if (datos.Apellidos === "") {
      props.mostrarMsg(["Por favor digite los Apellidos!"]);
      setCargando(false);
    } else if (datos.TipoDocumento === "") {
      props.mostrarMsg(["Por favor digite el Tipo de Documento!"]);
      setCargando(false);
    } else if (datos.NoDocumento === "") {
      props.mostrarMsg(["Por favor digite el Número de Documento!"]);
      setCargando(false);
    } else if (datos.MunicipioResidencia === "") {
      props.mostrarMsg(["Por favor seleccione el Municipio de Residencia!"]);
      setCargando(false);
    } else if (datos.MunicipioNacimiento === "") {
      props.mostrarMsg(["Por favor seleccione el Municipio de Nacimiento!"]);
      setCargando(false);
    } else if (datos.Direccion === "") {
      props.mostrarMsg(["Por favor digite la Dirección!"]);
      setCargando(false);
    } else if (datos.Celular === "") {
      props.mostrarMsg(["Por favor digite el Número de Celular!"]);
      setCargando(false);
    } else if (datos.Clave === "" && datos.id === "") {
      props.mostrarMsg([
        "Por favor digite una Clave de Acceso a la Plataforma!",
      ]);
      setCargando(false);
    } else {
      //primero verifico si existe el usuario en la tabla de usuario
      verificarExistenciaUsuario();
    }
  };

  const verificarExistenciaUsuario = async () => {
    try {
      setCargando(true);
      const res = await fetch(RUTA_SERVIDOR + "getCampo", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Campos: "Id",
          Tabla: "usuarios",
          Campo: "NoDocumento",
          Signo: "=",
          Valor: datos.NoDocumento,
        }),
      });
      const data = await res.json();

      // {datos.Id==='' ? grabarRegistro(): modificarRegistro()}
      // setServicios(data);
      // if (data.length > 0) {
      //   setServicios(data);
      // }
      setCargando(false);
    } catch (error) {
      setCargando(false);
      props.mostrarMsg([
        "No se pudo consultar la existencia del Documento de Identidad del Usuario!",
        error.message,
      ]);
    }
  };

  return (
    <div className="container-fluid card shadow mt-2" id="div_Top">
      <div className="row mt-3 mb-3">
        <Stack sx={{ width: "100%" }} spacing={2}>
          <Alert severity="info">
            <strong>FICHA DE CARACTERIZACION</strong>
          </Alert>
          {cargando === true && (
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Cargando...</span>
            </div>
          )}
        </Stack>
      </div>

      <div className="row">
        <div className="col-sm-4">
          <div className="input-group form-floating mt-2">
            <select
              name="TipoDocumento"
              className="form-select form-control"
              aria-label="TipoDocumento"
              value={datos.TipoDocumento}
              onChange={(event) => asignarDato(event)}
            >
              <option key="0" value="0">
                Tipo de Documento...
              </option>
              {tipoDocumentos.map((reg) => {
                return (
                  <option key={reg.Id} value={reg.Id} label={reg.Nbre}>
                    {" "}
                    {reg.Nbre}{" "}
                  </option>
                );
              })}
            </select>
          </div>
        </div>

        <div className="col-sm-4">
          <div className="row mt-2">
            <TextField
              style={{ marginTop: "10px" }}
              InputLabelProps={{ shrink: true }}
              name="NoDocumento"
              label="Número de Documento de Identidad"
              className="form-control"
              onChange={(event) => asignarDato(event)}
              onBlur={(event) => buscarFichaCaracterizacion(event.target.value)}
              type="text"
              value={datos.NoDocumento}
            />
          </div>
        </div>
        <div className="col-sm-4">
          <div className="input-group form-floating mt-2">
            <select
              name="MunicipioExp"
              className="form-select form-control"
              aria-label="MunicipioExp"
              value={datos.MunicipioExp}
              onChange={(event) => asignarDato(event)}
            >
              <option key="0" value="0">
                Municipio de Expedición...
              </option>
              {municipios.map((reg) => {
                return (
                  <option key={reg.Id} value={reg.Id} label={reg.Nbre}>
                    {" "}
                    {reg.Nbre}{" "}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-4">
          <TextField
            style={{ marginTop: "10px" }}
            InputLabelProps={{ shrink: true }}
            name="Nbres"
            label="Nombres"
            className="form-control"
            onChange={(event) => asignarDato(event)}
            type="text"
            value={datos.Nbres}
          />
        </div>
        <div className="col-sm-4">
          <TextField
            style={{ marginTop: "10px" }}
            InputLabelProps={{ shrink: true }}
            name="Apellidos"
            label="Apellidos"
            className="form-control"
            onChange={(event) => asignarDato(event)}
            type="text"
            value={datos.Apellidos}
          />
        </div>
        <div className="col-sm-4">
          <TextField
            style={{ marginTop: "10px" }}
            InputLabelProps={{ shrink: true }}
            name="Celular"
            label="Celular"
            className="form-control"
            onChange={(event) => asignarDato(event)}
            type="text"
            value={datos.Celular}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-sm-4">
          <Form>
            <div className="mb-3">
              <p>Género</p>
              <Form.Check
                inline
                checked={datos.Genero === "1"}
                label="Másculino"
                name="Genero"
                type={"radio"}
                value="1"
                onChange={(event) => asignarDato(event)}
              />
              <Form.Check
                inline
                checked={datos.Genero === "2"}
                label="Femenino"
                name="Genero"
                type={"radio"}
                value="2"
                onChange={(event) => asignarDato(event)}
              />
              <Form.Check
                inline
                checked={datos.Genero === "3"}
                label="Indeterminado"
                name="Genero"
                type={"radio"}
                value="3"
                onChange={(event) => asignarDato(event)}
              />
            </div>
          </Form>
        </div>

        <div className="col-sm-4">
          <TextField
            style={{ marginTop: "10px" }}
            InputLabelProps={{ shrink: true }}
            name="FechaNacimiento"
            label="Fecha de Nacimiento"
            className="form-control"
            onChange={(event) => asignarDato(event)}
            type="date"
            value={datos.FechaNacimiento}
          />
        </div>

        <div className="col-sm-4">
          <div className="input-group form-floating mt-2">
            <select
              name="MunicipioNacimiento"
              className="form-select form-control"
              aria-label="MunicipioNacimiento"
              value={datos.MunicipioNacimiento}
              onChange={(event) => asignarDato(event)}
            >
              <option key="0" value="0">
                Municipio de Nacimiento...
              </option>
              {municipios.map((reg) => {
                return (
                  <option key={reg.Id} value={reg.Id} label={reg.Nbre}>
                    {" "}
                    {reg.Nbre}{" "}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
      </div>

      <div className="row">
        <Form>
          <Form.Check
            inline
            checked={datos.Discapacidad}
            label="En Condición de discapacidad"
            id={`Discapacidad`}
            name="Discapacidad"
            type={"checkbox"}
            value={datos.Discapacidad}
            onChange={(event) => asignarDato(event)}
          />
        </Form>
      </div>

      <div className="row mt-3">
        <Stack sx={{ width: "100%" }} spacing={2}>
          <Alert severity="success">Datos de Residencia</Alert>
        </Stack>
      </div>

      <div className="row">
        <div className="col-sm-4">
          <div className="input-group form-floating mt-2">
            <select
              name="MunicipioResidencia"
              className="form-select form-control"
              aria-label="MunicipioResidencia"
              value={datos.MunicipioResidencia}
              onChange={(event) => asignarDato(event)}
            >
              <option key="0" value="0">
                Municipio de Residencia...
              </option>
              {municipios.map((reg) => {
                return (
                  <option key={reg.Id} value={reg.Id} label={reg.Nbre}>
                    {" "}
                    {reg.Nbre}{" "}
                  </option>
                );
              })}
            </select>
          </div>
        </div>

        <div className="col-sm-4">
          <TextField
            style={{ marginTop: "10px" }}
            InputLabelProps={{ shrink: true }}
            name="Direccion"
            label="Dirección de Residencia"
            className="form-control"
            onChange={(event) => asignarDato(event)}
            type="text"
            value={datos.Direccion}
          />
        </div>

        <div className="col-sm-4">
          <TextField
            style={{ marginTop: "10px" }}
            InputLabelProps={{ shrink: true }}
            name="Barrio"
            label="Barrio de Residencia"
            className="form-control"
            onChange={(event) => asignarDato(event)}
            type="text"
            value={datos.Barrio}
          />
        </div>
      </div>

      <div className="row mt-3">
        <Form>
          <p>Tipo de Vivienda</p>
          <Form.Check
            inline
            checked={datos.TipoVivienda === "1"}
            label="Casa"
            name="TipoVivienda"
            type={"radio"}
            value={"1"}
            onChange={(event) => asignarDato(event)}
          />
          <Form.Check
            inline
            checked={datos.TipoVivienda === "2"}
            label="Apartamento"
            name="TipoVivienda"
            type={"radio"}
            value={"2"}
            onChange={(event) => asignarDato(event)}
          />
          <Form.Check
            inline
            checked={datos.TipoVivienda === "3"}
            label="Vivienda Indigena"
            name="TipoVivienda"
            type={"radio"}
            value={"3"}
            onChange={(event) => asignarDato(event)}
          />
          <Form.Check
            inline
            checked={datos.TipoVivienda === "4"}
            label="Cambuche"
            name="TipoVivienda"
            type={"radio"}
            value={"4"}
            onChange={(event) => asignarDato(event)}
          />
          <Form.Check
            inline
            checked={datos.TipoVivienda === "5"}
            label="Habitación"
            name="TipoVivienda"
            type={"radio"}
            value={"5"}
            onChange={(event) => asignarDato(event)}
          />
          <Form.Check
            inline
            checked={datos.TipoVivienda === "6"}
            label="Finca"
            name="TipoVivienda"
            type={"radio"}
            value={"6"}
            onChange={(event) => asignarDato(event)}
          />
          <Form.Check
            inline
            checked={datos.TipoVivienda === "7"}
            label="Inquilinato"
            name="TipoVivienda"
            type={"radio"}
            value={"7"}
            onChange={(event) => asignarDato(event)}
          />
          <Form.Check
            inline
            checked={datos.TipoVivienda === "8"}
            label="Albergue"
            name="TipoVivienda"
            type={"radio"}
            value={"8"}
            onChange={(event) => asignarDato(event)}
          />
        </Form>
      </div>
      <hr />

      <div className="row">
        <div className="col-sm-4">
          <Form>
            <p>Tiempo de permanencia</p>
            <Form.Check
              checked={datos.Permanencia === "1"}
              label="Menos de 1 año"
              name="Permanencia"
              type={"radio"}
              value="1"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Permanencia === "2"}
              label="De 1 a 5 años"
              name="Permanencia"
              type={"radio"}
              value="2"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Permanencia === "3"}
              label="Mas de 5 años"
              name="Permanencia"
              type={"radio"}
              value="3"
              onChange={(event) => asignarDato(event)}
            />
          </Form>
        </div>

        <div className="col-sm-4">
          <TextField
            style={{ marginTop: "10px" }}
            InputLabelProps={{ shrink: true }}
            name="GrupoFamiliar"
            label="Número de personas del grupo familiar"
            className="form-control"
            onChange={(event) => asignarDato(event)}
            type="text"
            value={datos.GrupoFamiliar}
          />
        </div>

        <div className="col-sm-4">
          <Form>
            <p>Zona</p>
            <Form.Check
              checked={datos.Zona === "1"}
              inline
              label="Zona Urbana"
              name="Zona"
              type={"radio"}
              value="1"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Zona === "2"}
              inline
              label="Zona Rural"
              name="Zona"
              type={"radio"}
              value="2"
              onChange={(event) => asignarDato(event)}
            />
          </Form>
        </div>
      </div>

      <hr />

      <div className="row">
        <div className="col-sm-4">
          <Form>
            <p>Estrato Socio-Económico</p>
            <Form.Check
              checked={datos.Estrato === "1"}
              label="1"
              name="Estrato"
              type={"radio"}
              value="1"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Estrato === "2"}
              label="2"
              name="Estrato"
              type={"radio"}
              value="2"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Estrato === "3"}
              label="3"
              name="Estrato"
              type={"radio"}
              value="3"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Estrato === "4"}
              label="4"
              name="Estrato"
              type={"radio"}
              value="4"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Estrato === "5"}
              label="5"
              name="Estrato"
              type={"radio"}
              value="5"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Estrato === "6"}
              label="6"
              name="Estrato"
              type={"radio"}
              value="6"
              onChange={(event) => asignarDato(event)}
            />
          </Form>
        </div>

        <div className="col-sm-4">
          <Form>
            <p>Vivienda</p>
            <Form.Check
              checked={datos.Vivienda === "1"}
              label="Propia"
              name="Vivienda"
              type={"radio"}
              value="1"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Vivienda === "2"}
              label="Arrendada"
              name="Vivienda"
              type={"radio"}
              value="2"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Vivienda === "3"}
              label="Prestada"
              name="Vivienda"
              type={"radio"}
              value="3"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Vivienda === "4"}
              label="Familiar"
              name="Vivienda"
              type={"radio"}
              value="4"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Vivienda === "5"}
              label="Posesión sin título"
              name="Vivienda"
              type={"radio"}
              value="5"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Vivienda === "6"}
              label="Ocupación de hecho"
              name="Vivienda"
              type={"radio"}
              value="6"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Vivienda === "7"}
              label="En Concesión"
              name="Vivienda"
              type={"radio"}
              value="7"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Vivienda === "8"}
              label="Titulación Comunitaria"
              name="Vivienda"
              type={"radio"}
              value="8"
              onChange={(event) => asignarDato(event)}
            />
          </Form>
        </div>

        <div className="col-sm-4">
          <Form>
            <p>Servicios Básicos de la Vivienda</p>

            <Form.Check
              checked={datos.Agua}
              label="Agua"
              name="Agua"
              type={"checkbox"}
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Alcantarillado}
              label="Alcantarillado"
              name="Alcantarillado"
              type={"checkbox"}
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Energia}
              label="Energía Eléctrica"
              name="Energia"
              type={"checkbox"}
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Gas}
              label="Gas"
              name="Gas"
              type={"checkbox"}
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Telefonia}
              label="Telefonía fija"
              name="Telefonia"
              type={"checkbox"}
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Internet}
              label="Internet"
              name="Internet"
              type={"checkbox"}
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Basuras}
              label="Recolección de basuras"
              name="Basuras"
              type={"checkbox"}
              onChange={(event) => asignarDato(event)}
            />
          </Form>
        </div>
      </div>

      <hr />
      <div className="row">
        <Form>
          <p>Grupo Poblacional</p>
          <Form.Check
            checked={datos.Poblacion === "1"}
            inline
            label="Indigena"
            name="Poblacion"
            type={"radio"}
            value="1"
            onChange={(event) => asignarDato(event)}
          />
          <Form.Check
            checked={datos.Poblacion === "2"}
            inline
            label="Afro"
            name="Poblacion"
            type={"radio"}
            value="2"
            onChange={(event) => asignarDato(event)}
          />
          <Form.Check
            checked={datos.Poblacion === "3"}
            inline
            label="ROM / Gitano"
            name="Poblacion"
            type={"radio"}
            value="3"
            onChange={(event) => asignarDato(event)}
          />
          <Form.Check
            checked={datos.Poblacion === "4"}
            inline
            label="Mulato"
            name="Poblacion"
            type={"radio"}
            value="4"
            onChange={(event) => asignarDato(event)}
          />
          <Form.Check
            checked={datos.Poblacion === "5"}
            inline
            label="Palenquero"
            name="Poblacion"
            type={"radio"}
            value="5"
            onChange={(event) => asignarDato(event)}
          />
          <Form.Check
            checked={datos.Poblacion === "6"}
            inline
            label="Raizal"
            name="Poblacion"
            type={"radio"}
            value="6"
            onChange={(event) => asignarDato(event)}
          />
          <Form.Check
            checked={datos.Poblacion === "7"}
            inline
            label="Ninguno de los anteriores"
            name="Poblacion"
            type={"radio"}
            value="7"
            onChange={(event) => asignarDato(event)}
          />
        </Form>
      </div>

      <div className="row mt-3">
        <Stack sx={{ width: "100%" }} spacing={2}>
          <Alert severity="success">Escolaridad</Alert>
        </Stack>
      </div>

      <div className="row">
        <div className="col-sm-3">
          <Form>
            <p>Escolaridad</p>
            <Form.Check
              checked={datos.Escolaridad === "1"}
              label="Analfabeta"
              name="Escolaridad"
              type={"radio"}
              value="1"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Escolaridad === "2"}
              label="Primaria"
              name="Escolaridad"
              type={"radio"}
              value="2"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Escolaridad === "3"}
              label="Secúndaria"
              name="Escolaridad"
              type={"radio"}
              value="3"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Escolaridad === "4"}
              label="Técnico"
              name="Escolaridad"
              type={"radio"}
              value="4"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Escolaridad === "5"}
              label="Tecnologo"
              name="Escolaridad"
              type={"radio"}
              value="5"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Escolaridad === "6"}
              label="Universitario"
              name="Escolaridad"
              type={"radio"}
              value="6"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Escolaridad === "7"}
              label="Posgrado"
              name="Escolaridad"
              type={"radio"}
              value="7"
              onChange={(event) => asignarDato(event)}
            />
          </Form>
        </div>

        <div className="col-sm-3">
          <Form>
            <p>Semestres de estudio</p>
            <Form.Check
              checked={datos.Semestres === "1"}
              label="Completo"
              name="Semestres"
              type={"radio"}
              value={`1`}
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Semestres === "2"}
              label="Un semestre"
              name="Semestres"
              type={"radio"}
              value={`2`}
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Semestres === "3"}
              label="Dos semestres"
              name="Semestres"
              type={"radio"}
              value={`3`}
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Semestres === "4"}
              label="Tres semestre"
              name="Semestres"
              type={"radio"}
              value={`4`}
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Semestres === "5"}
              label="Cuatro semestres"
              name="Semestres"
              type={"radio"}
              value={`5`}
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Semestres === "6"}
              label="Cinco semestres"
              name="Semestres"
              type={"radio"}
              value={`6`}
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Semestres === "7"}
              label="Seis semestres"
              name="Semestres"
              type={"radio"}
              value={`7`}
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Semestres === "8"}
              label="Siete semestres"
              name="Semestres"
              type={"radio"}
              value={`8`}
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Semestres === "9"}
              label="Ocho semestres"
              name="Semestres"
              type={"radio"}
              value={`9`}
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Semestres === "10"}
              label="Nueve semestres"
              name="Semestres"
              type={"radio"}
              value={`10`}
              onChange={(event) => asignarDato(event)}
            />
          </Form>
        </div>

        <div className="col-sm-3">
          <Form>
            <p>Años de estudio</p>
            <Form.Check
              checked={datos.Anios === "1"}
              label="Completo"
              name="Anios"
              type={"radio"}
              value={`1`}
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Anios === "2"}
              label="Un año"
              name="Anios"
              type={"radio"}
              value={`2`}
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Anios === "3"}
              label="Dos años"
              name="Anios"
              type={"radio"}
              value={`3`}
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Anios === "4"}
              label="Tres años"
              name="Anios"
              type={"radio"}
              value={`4`}
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Anios === "5"}
              label="Cuatro años"
              name="Anios"
              type={"radio"}
              value={`5`}
              onChange={(event) => asignarDato(event)}
            />
          </Form>
        </div>
      </div>

      <div className="row mt-3">
        <Stack sx={{ width: "100%" }} spacing={2}>
          <Alert severity="success">
            Active los programas del Estado a los cuales pertenece
          </Alert>
        </Stack>
      </div>

      <div className="row mt-3">
        <div className="col-sm-4">
          <Form>
            <Alert severity="info">Agencia Nacional de Tierras</Alert>
            <Form.Check
              checked={datos.Baldios}
              type="switch"
              name="Baldios"
              label="Adjudicación de baldíos"
              onChange={(event) => asignarDato(event)}
            />

            <Alert severity="info">Ejército Nacional</Alert>
            <Form.Check
              checked={datos.Excencion}
              type="switch"
              name="Excencion"
              label="Exención en el pago de la cuota de compensación militar"
              onChange={(event) => asignarDato(event)}
            />

            <Alert severity="info">ICBF</Alert>
            <Form.Check
              checked={datos.PrimeraInfancia}
              type="switch"
              name="PrimeraInfancia"
              label="Atención Integral a la Primera Infancia"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Infancia}
              type="switch"
              name="Infancia"
              label="Infancia"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.AdolescenciaJuventud}
              type="switch"
              name="AdolescenciaJuventud"
              label="Adolescencia y Juventud "
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Nutricion}
              type="switch"
              name="Nutricion"
              label="Nutrición"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Proteccion}
              type="switch"
              name="Proteccion"
              label="Protección (Hogar gestor y otros similares)"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Familias}
              type="switch"
              name="Familias"
              label="Familias y Comunidades"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.TuEliges}
              type="switch"
              name="TuEliges"
              label="Tú Eliges"
              onChange={(event) => asignarDato(event)}
            />
          </Form>
        </div>
        <div className="col-sm-4">
          <Form>
            <Alert severity="info">Ministerio de Educación</Alert>
            <Form.Check
              checked={datos.Equidad}
              type="switch"
              name="Equidad"
              label="Generación E Equidad "
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Excelencia}
              type="switch"
              name="Excelencia"
              label="Generación E Excelencia"
              onChange={(event) => asignarDato(event)}
            />

            <Alert severity="info">Ministerio de Minas y Energía</Alert>
            <Form.Check
              checked={datos.Petroleo}
              type="switch"
              name="Petroleo"
              label="Subsidio Gas Licuado de Petróleo - GLP "
              onChange={(event) => asignarDato(event)}
            />

            <Alert severity="info">
              Ministerio de Salud y Protección Social
            </Alert>
            <Form.Check
              checked={datos.Subsidiado}
              type="switch"
              name="Subsidiado"
              label="Régimen Subsidiado de Salud"
              onChange={(event) => asignarDato(event)}
            />

            <Alert severity="info">Ministerio de Vivienda</Alert>
            <Form.Check
              checked={datos.CasaDigna}
              type="switch"
              name="CasaDigna"
              label="Casa Digna Vida Digna"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.ViviendaRural}
              type="switch"
              name="ViviendaRural"
              label="Vivienda Rural"
              onChange={(event) => asignarDato(event)}
            />

            <Alert severity="info">Prosperidad Social</Alert>
            <Form.Check
              checked={datos.ColombiaMayor}
              type="switch"
              name="ColombiaMayor"
              label="Colombia Mayor"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.FamiliasAccion}
              type="switch"
              name="FamiliasAccion"
              label="Familias en Acción"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.JovenesAccion}
              type="switch"
              name="JovenesAccion"
              label="Jóvenes en Acción"
              onChange={(event) => asignarDato(event)}
            />
          </Form>
        </div>
        <div className="col-sm-4">
          <Form>
            <Alert severity="info">Prosperidad Social</Alert>
            <Form.Check
              checked={datos.Unidos}
              type="switch"
              name="Unidos"
              label="Red Unidos"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.IngresoSolidario}
              type="switch"
              name="IngresoSolidario"
              label="Ingreso Solidario"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Iva}
              type="switch"
              name="Iva"
              label="Compensación de IVA"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Resa}
              type="switch"
              name="Resa"
              label="RESA"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.MiNegocio}
              type="switch"
              name="MiNegocio"
              label="Mi Negocio"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Colectivo}
              type="switch"
              name="Colectivo"
              label="Emprendimientos Colectivo"
              onChange={(event) => asignarDato(event)}
            />

            <Alert severity="info">Registraduría Nacional</Alert>
            <Form.Check
              checked={datos.ExeccionCedula}
              type="switch"
              name="ExeccionCedula"
              label="Exención en el pago de la cédula de ciudadanía"
              onChange={(event) => asignarDato(event)}
            />

            <Alert severity="info">Unidad de Alimentación Escolar</Alert>
            <Form.Check
              checked={datos.AlimentacionEscolar}
              type="switch"
              name="AlimentacionEscolar"
              label="Programa de Alimentación Escolar PAE"
              onChange={(event) => asignarDato(event)}
            />

            <Alert severity="info">Unidad para las Víctimas</Alert>
            <Form.Check
              checked={datos.AtencionHumanitaria}
              type="switch"
              name="AtencionHumanitaria"
              label="Atención Humanitaria"
              onChange={(event) => asignarDato(event)}
            />
          </Form>
        </div>
      </div>
      <hr />

      <div className="row">
        <div className="col-sm-4">
          <TextField
            style={{ marginTop: "10px" }}
            InputLabelProps={{ shrink: true }}
            name="Sisben"
            label="Puntaje Sisben"
            className="form-control"
            onChange={(event) => asignarDato(event)}
            type="text"
            value={datos.Sisben}
          />
        </div>

        <div className="col-sm-4">
          <div className="input-group form-floating mt-2">
            <select
              name="eps"
              className="form-select form-control"
              aria-label="Eps"
              value={datos.Eps}
              onChange={(event) => asignarDato(event)}
            >
              <option key="0" value="0">
                EPS...
              </option>
              {listaEps.map((reg) => {
                return (
                  <option key={reg.Id} value={reg.Id} label={reg.Nbre}>
                    {" "}
                    {reg.Nbre}{" "}
                  </option>
                );
              })}
            </select>
          </div>
        </div>

        <div className="col-sm-4"></div>
      </div>

      <div className="row mt-3">
        <div className="col-sm-4">
          <Form>
            <Alert severity="info">Ocupación</Alert>
            <Form.Check
              checked={datos.Ocupacion === "1"}
              label="Desempleado"
              name="Ocupacion"
              type={"radio"}
              value={`1`}
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Ocupacion === "2"}
              label="Empleado"
              name="Ocupacion"
              type={"radio"}
              value={`2`}
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Ocupacion === "3"}
              label="Trabajo Informal"
              name="Ocupacion"
              type={"radio"}
              value={`3`}
              onChange={(event) => asignarDato(event)}
            />
          </Form>
        </div>

        <div className="col-sm-4">
          <Form>
            <Alert severity="info">Tipos de Vehículos</Alert>
            <Form.Check
              checked={datos.Bicicleta}
              type="switch"
              name="Bicicleta"
              label="Bicicleta"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Moto}
              type="switch"
              name="Moto"
              label="Moto"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Carro}
              type="switch"
              name="Carro"
              label="Carro"
              onChange={(event) => asignarDato(event)}
            />
          </Form>
        </div>

        <div className="col-sm-4">
          <Form>
            <Alert severity="info">Habilidades</Alert>
            <Form.Check
              checked={datos.Leer}
              type="switch"
              name="Leer"
              label="Leer"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Escribir}
              type="switch"
              name="Escribir"
              label="Escribir"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Cantar}
              type="switch"
              name="Cantar"
              label="Cantar"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Bailar}
              type="switch"
              name="Bailar"
              label="Bailar"
              onChange={(event) => asignarDato(event)}
            />
            <Form.Check
              checked={datos.Deportista}
              type="switch"
              name="Deportista"
              label="Deportista"
              onChange={(event) => asignarDato(event)}
            />
          </Form>
        </div>
      </div>

      <div className="row mt-3">
        <Stack sx={{ width: "100%" }} spacing={2}>
          <Alert severity="info">
            Diligencie estos datos si el Participante del Proyecto NO es el
            principal, sino un familiar Beneficiario
          </Alert>
        </Stack>
      </div>

      <div className="row mt-2">
        <div className="col-sm-6">
          <TextField
            style={{ marginTop: "10px" }}
            InputLabelProps={{ shrink: true }}
            name="Principal"
            label="Número de Documento del Principal"
            className="form-control"
            onChange={(event) => asignarDato(event)}
            type="text"
            value={datos.Principal}
          />
        </div>
        <div className="col-sm-6">
          <div className="input-group form-floating">
            <select
              name="Familiaridad"
              className="form-select form-control"
              aria-label="Familiaridad"
              value={datos.Familiaridad}
              onChange={(event) => asignarDato(event)}
            >
              <option key="0" value="0">
                Por favor seleccione un Tipo de Familiaridad...
              </option>
              {familiaridad.map((reg) => {
                return (
                  <option key={reg.Id} value={reg.Id} label={reg.Nbre}>
                    {" "}
                    {reg.Nbre}{" "}
                  </option>
                );
              })}
            </select>
            <button
              className="btn btn-primary"
              type="button"
              onClick={(event) => {
                mostrarVentanaCrear(event, "TIPO DE FAMILIARIDAD");
              }}
            >
              <FaFileMedical />
            </button>
          </div>
        </div>
      </div>

      <div className="row mt-3">
        <Stack sx={{ width: "100%" }} spacing={2}>
          <Alert severity="success">
            Credenciales de acceso a la plataforma
          </Alert>
        </Stack>
      </div>

      <div className="row">
        <div className="col-sm-6">
          <TextField
            style={{ marginTop: "10px" }}
            InputLabelProps={{ shrink: true }}
            name="Correo"
            label="Dirección de Correo"
            className="form-control"
            onChange={(event) => asignarDato(event)}
            type="text"
            value={datos.Correo}
          />
        </div>
        <div className="col-sm-6">
          <TextField
            style={{ marginTop: "10px" }}
            InputLabelProps={{ shrink: true }}
            name="Clave"
            label="Clave de Acceso"
            className="form-control"
            onChange={(event) => asignarDato(event)}
            type="password"
            value={datos.Clave}
          />
        </div>
      </div>

      <div className="row mt-2">
        <FormGroup>
          <FormControlLabel
            name="Activo"
            control={
              <Switch
                checked={datos.Activo}
                onChange={(event) => asignarDato(event)}
                inputProps={{ "aria-label": "Activo" }}
                //defaultChecked
              />
            }
            label="Estado"
            labelPlacement="start"
          />
        </FormGroup>
      </div>

      <div className="row mt-3">
        <Divider component="ul" />
        <BarraBotones
          botones={botones}
          btnActivos={[true, true, false, true, true]}
        />
      </div>

      {mostrarCrear && (
        <VentanaCrear
          titulo={"PARTICIPANTE BENEFICIARIO"}
          cerrarVentanaCrear={cerrarVentanaCrear}
          grabarCampo={grabarCampo}
        />
      )}
    </div>
  );
};

export default Caracterizacion;
